import { useMutation, useQueryClient } from "@tanstack/react-query";
import { merchantKeys } from "Api/Queries/Merchants/useGetMerchantQuery";
import {
  apiPut,
  getApiUrl,
  putMerchantsPublicIDAvatarPath,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  merchantPublicID: string;
  file: Blob;
};

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

/**
 * Back-office/onboarding upload of a merchant's image — the founder Merchant persona's avatar
 * (ZS-1607). The merchant persona itself uses the self-service profile photo mutation instead.
 */
export const useUploadMerchantAvatarMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      async ({ merchantPublicID, file }: Parameters) => {
        const path = putMerchantsPublicIDAvatarPath(merchantPublicID);
        const form = new FormData();
        form.append("file", file);

        return apiPut(`${getApiUrl()}${path}`, form, {});
      },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: merchantKeys.all,
      });
      onSuccess?.();
    },
    onError,
  });
};
